<template>
  <div>
      <el-dialog  :visible="qrCodeShow" @close="closeDia" width="400px" center>
        <div class="img-wrap">
            <el-image
                :src="item.image"
                fit="fill"  v-for="(item, idx) in params.list" 
                :key="idx" @click="itemClick(item)"></el-image>
        </div>
          

    </el-dialog>
  </div>
</template>

<script>
import {linkCommon } from '@/utils/index.js'

export default {
    props: {
        params: {
            type: [Object, Array]
        }
    },
    data() {
        return {
            qrCodeShow: true
        }
    },
    methods: {
        itemClick(v) {
            linkCommon(v, this)
        },
        closeDia() {
            this.qrCodeShow = false
        }
    }
}
</script>


<style lang="scss">
.el-dialog__headerbtn{
    top: 10px;
}
.img-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}
</style>